<template>
  <v-server-table
    class="other-shiurim-table"
    :name="'otherShiurimTable' + type"
    :ref="'otherShiurimTable' + type"
    :url="'/api/shiurim/torah/' + type"
    :columns="columns"
    :options="options"
  >
    <div slot="beforeTable" class="py-3 d-md-none">
      <div class="d-flex flex-wrap w-100 d-md-none align-items-center justify-content-center">
        <strong class="col-auto">{{ $_t('KW:filterBy') }}:</strong>
        <input class="form-control select-filter" v-model="filtername" :placeholder="$_t('KW:searchShiurim')" />
        <!-- <v-select
          v-if="magideiShiur.length > 0"
          class="w-100 select-filter"
          v-model="filterSpeakers"
          :placeholder="$_t('KW:filterMagidShiur')"
          :options="magideiShiur"
        ></v-select> -->
      </div>
      <div class="d-flex flex-wrap w-100 d-md-none align-items-center justify-content-center">
        <strong clas="col-auto">{{ $_t('KW:sortBy') }}:</strong>
        <button class="col-auto btn btn-sm btn-link" @click="sortItems('name')">
          {{ $_t('KW:title') }}
          <i class="fa" :class="setOrderClass('name')"></i>
        </button>
        <button class="col-auto btn btn-sm btn-link topic-sort" @click="sortItems('topic_id')">
          {{ $_t('KW:topic') }}
          <i class="fa" :class="setOrderClass('topic_id')"></i>
        </button>
        <button class="col-auto btn btn-sm btn-link magid-sort" @click="sortItems('speaker_id')">
          {{ $_t('KW:magidShiur') }}
          <i class="fa" :class="setOrderClass('speaker_id')"></i>
        </button>
        <button class="col-auto btn btn-sm btn-link" @click="sortItems('recorded')">
          {{ $_t('KW:date') }}
          <i class="fa" :class="setOrderClass('recorded')"></i>
        </button>
        <button class="col-auto btn btn-sm btn-link" @click="sortItems('length')">
          {{ $_t('KW:length') }}
          <i class="fa" :class="setOrderClass('length')"></i>
        </button>
      </div>
    </div>
    <div slot="filter__name">
      <input class="form-control search-filter" v-model="filtername" :placeholder="$_t('KW:searchShiurim')" />
    </div>
    <v-select
      v-if="magideiShiur.length > 0"
      slot="filter__speaker_id"
      class="select-filter"
      v-model="filterSpeakers"
      :placeholder="$_t('KW:filterMagidShiur')"
      :options="magideiShiur"
    ></v-select>
    <v-select
      v-if="topics.length > 0"
      slot="filter__topic_id"
      class="select-filter"
      v-model="filterTopics"
      :placeholder="$_t('KW:filterTopic')"
      :options="topics"
    ></v-select>

    <div slot="mobile" slot-scope="props">
      <strong>
        <a :href="'/shiur/' + props.row.id">{{ props.row.name }}</a>
      </strong>
      {{ props.row.length }}
      <br />
      <topic-link :topic="props.row.topic"></topic-link>
      <br />
      <strong>
        <router-link
          :to="{
            name: 'magideiShiurTorah',
            params: { slug: props.row.speaker.url_key },
          }"
          >{{ props.row.speaker.name }}</router-link
        >
      </strong>
    </div>
    <a slot="name" slot-scope="props" :href="'/shiur/' + props.row.id">{{ props.row.name }}</a>
    <router-link
      :to="{
        name: 'magideiShiurTorah',
        params: { slug: props.row.speaker.url_key },
      }"
      slot="speaker_id"
      slot-scope="props"
      class="row align-items-center mx-2"
    >
      <b-img-lazy blank-src="/static/blank_profile.jpg" :src="imgsrc(props.row.speaker)" fluid :alt="props.row.speaker.name" class="col-auto mw-50" />
      <div class="col">{{ props.row.speaker.name }}</div>
    </router-link>
    <div slot="topic_id" slot-scope="props" class="row align-items-center">
      <div class="col">
        <topic-link :topic="props.row.topic"></topic-link>
      </div>
    </div>
    <action-buttons slot="actions" :magid-shiur="props.row.speaker" :shiurim="props.row" type="torah" slot-scope="props"></action-buttons>
  </v-server-table>
</template>
<script>
import VueSelect from 'vue-select';
import { Event as VueTablesEvent } from 'vue-tables-2';
import ActionButtonsComponent from '../partials/ActionButtons.vue';
import TopicLinkComponent from '../magideiShiur/topicLink.vue';

export default {
  components: {
    ActionButtons: ActionButtonsComponent,
    TopicLink: TopicLinkComponent,
    vSelect: VueSelect,
  },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'shiurimTable',
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return ['popular', 'recent', 'parsha'].indexOf(value) !== -1;
      },
    },
  },
  data: function () {
    return {
      filtername: null,
      filterSpeakers: null,
      filterTopics: null,
      magideiShiur: [],
      topics: [],
      columns: ['mobile', 'name', 'speaker_id', 'topic_id', 'recorded', 'length', 'actions'],
      options: {
        headings: {
          mobile: '',
          title: this.$_t('KW:title'),
          topic_id: this.$_t('KW:topic'),
          speaker_id: this.$_t('KW:magidShiur'),
          name: this.$_t('KW:title'),
          recorded: this.$_t('KW:date'),
          length: this.$_t('KW:time'),
          actions: this.$_t('KW:playOrDownload'),
        },
        sortIcon: {
          base: 'fa fa-sort',
          up: 'fa-sort-amount-asc',
          down: 'fa-sort-amount-desc',
        },
        columnsDisplay: {
          mobile: 'max_tabletP',
          name: 'min_tabletL',
          topic_id: 'min_tabletL',
          speaker_id: 'min_tabletL',
          length: 'min_tabletL',
          recorded: 'min_tabletL',
        },
        sortable: ['name', 'speaker_id', 'topic_id', 'length', 'recorded'],
        highlightMatches: true,
        filterByColumn: true,
        filterable: [],
        customFilters: ['name', 'speaker_id', 'topic_id'],
        perPage: 50,
        perPageValues: [50, 100],
        // orderBy: {
        //   column: "recorded",
        //   ascending: false
        // }
      },
      order: {
        column: null,
        isAscending: true,
      },
    };
  },
  watch: {
    filtername: function () {
      VueTablesEvent.$emit('vue-tables.otherShiurimTable' + this.type + '.filter::name', this.filtername);
    },
    filterSpeakers: function () {
      VueTablesEvent.$emit('vue-tables.otherShiurimTable' + this.type + '.filter::speaker_id', this.filterSpeakers ? this.filterSpeakers.value : '0');
    },
    filterTopics: function () {
      VueTablesEvent.$emit('vue-tables.otherShiurimTable' + this.type + '.filter::topic_id', this.filterTopics ? this.filterTopics.value : '0');
    },
  },
  created: function () {
    this.getMagideiShiur();
    this.getTopics();
  },
  methods: {
    slug: function (val) {
      if (val) {
        var result = val
          .toString()
          .toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(/[^\w\-]+/g, '') // Remove all non-word chars
          .replace(/\-\-+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, ''); // Trim - from end of text
        if (!result || 0 === result.length) {
          return 'hebrew';
        }
        return result;
      }
      return 'not-specified';
    },
    imgsrc: function (magidShiur) {
      if (magidShiur.image) {
        return magidShiur.image.url;
      } else {
        return '/static/blank_profile.jpg';
      }
    },
    sortItems: function (column) {
      if (this.order.column !== column) {
        this.order.column = column;
        this.order.isAscending = true;
      } else {
        this.order.isAscending = !this.order.isAscending;
      }
      this.$refs['otherShiurimTable' + this.type].setOrder(this.order.column, this.order.isAscending);
    },
    setOrderClass: function (name) {
      if (name == this.order.column) {
        return this.order.isAscending ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc';
      }
      return 'fa-sort';
    },
    getMagideiShiur: function () {
      this.$http.get('/api/shiurim/torah/' + this.type + '/speakers').then(response => {
        this.magideiShiur = response.data;
      });
    },
    getTopics: function () {
      this.$http.get('/api/shiurim/torah/' + this.type + '/topics').then(response => {
        this.topics = response.data;
      });
    },
  },
};
</script>
<style lang="scss">
th#VueTables_th--topic_id {
  width: 200px;
}
#VueTables_th--name {
  width: 300px;
}
@media (max-width: 768px) {
  input.select-filter {
    height: 45px;
  }
  .select-filter {
    margin-bottom: 15px;
    .dropdown-toggle {
      height: 45px;
    }
    ul.dropdown-menu li {
      padding: 5px 0px;
    }
    .dropdown-toggle {
      height: 45px;
    }
  }
}
</style>
